import React, { Fragment } from 'react'

import meetingPreview from 'images/meetingPreview.svg'

const MeetingPreview = () => (
  <Fragment>
    <img src={meetingPreview} alt="meeting-preview" />
  </Fragment>
)

export default MeetingPreview
